import axios from 'axios';

export default {
    getInformation(cb, { ClinicId, ClientToken }) {
        axios
        .get(`/api/Clinic?ClinicId=${ClinicId}&includeNextAvailableAppointment=true`, {
            headers: {
                Authorization: `Bearer ${ClientToken}`,
                Dealer: sessionStorage.getItem('dealer')
            }
        })
            .then(response => response.data)
            .then(data => {
                cb(data);
            })
            .catch(err => cb(err.response));
    },
};
